import { IJsxChildren } from "./IJsxChildren";
import { NAMESPACE } from "./_Namespace";

export class JsxFragment implements IJsxChildren
{
    public static classNamespace = NAMESPACE + "JsxFragment";
    public static className = "JsxFragment";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    children?: JsxFragment | string | (JsxFragment | string | undefined | (JsxFragment | string | undefined)[])[];
}